export const title = "Decision Aids";
export const logoTitle = "iDeAs";
export const copyright =
  "© Copyright by Evidence Prime __date__. All Rights Reserved";
export const tosLink = "https://gradepro.org/tos.html";
export const cookiesLink = "https://gradepro.org/cookies.html";
export const privacyLink = "https://gradepro.org/privacy.html";

export const serverStaticUrl =
  // eslint-disable-next-line no-undef
  process.env.NODE_ENV !== "production"
    ? "https://gdt.test.evidenceprime.com/static"
    : `${window.location.origin}/static`;
